const featuredNewsData = [
  {
    id: 1,
    date: "08-11-2021",
    category: "Category",
    title: "Believing neglected so so allowance existence departure.",
    description:
      "Blessing welcomed ladyship she met humoured sir breeding her. Six curiosity day assurance bed necessary.",
    image: "/assets/images/News/news1.webp",
  },
  {
    id: 2,
    date: "08-11-2021",
    category: "Category",
    title: "Believing neglected so so allowance existence departure.",
    description:
      "Blessing welcomed ladyship she met humoured sir breeding her. Six curiosity day assurance bed necessary.",
    image: "/assets/images/News/news2.webp",
  },
  {
    id: 3,
    date: "08-11-2021",
    category: "Category",
    title: "Believing neglected so so allowance existence departure.",
    description:
      "Blessing welcomed ladyship she met humoured sir breeding her. Six curiosity day assurance bed necessary.",
    image: "/assets/images/News/news3.webp",
  },
  {
    id: 4,
    date: "08-11-2021",
    category: "Category",
    title: "Believing neglected so so allowance existence departure.",
    description:
      "Blessing welcomed ladyship she met humoured sir breeding her. Six curiosity day assurance bed necessary.",
    image: "/assets/images/News/news4.webp",
  },
];

export default featuredNewsData;
